import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

/**
 * Componente de tarjeta para mostrar un combo en la vista de lista con animaciones.
 * @param {Object} props
 * @param {Object} props.combo - Datos del combo.
 * @param {number} props.index - Índice para animaciones escalonadas.
 */
export default function ComboCard({ combo, index = 0 }) {
  // Función para formatear precio en pesos chilenos
  const formatPrice = (price) => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    }).format(price);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.5,
        delay: index * 0.1,
        type: 'spring',
        stiffness: 100
      }}
      whileHover={{
        y: -8,
        scale: 1.02,
        transition: { duration: 0.2 }
      }}
      className="rounded-lg border border-gray-200 shadow-sm bg-white flex flex-col overflow-hidden hover:shadow-2xl transition-all"
    >
      <motion.div
        className="p-6 flex-1 flex flex-col"
        whileHover={{ backgroundColor: '#fafafa' }}
      >
        <div className="flex justify-between items-start mb-1">
          <motion.h3
            className="text-xl font-semibold text-primary"
            whileHover={{ scale: 1.02, color: '#c41e3a' }}
          >
            {combo.name}
          </motion.h3>
          <motion.div
            whileHover={{ scale: 1.1 }}
            className="bg-primary text-white px-3 py-1 rounded-full text-sm font-bold"
          >
            {formatPrice(combo.price)}
          </motion.div>
        </div>
        <p className="text-sm text-gray-600 mb-3 font-medium">{combo.persons}</p>

        <ul className="text-sm text-gray-700 flex-1 space-y-1">
          {combo.items.slice(0, 4).map((item, idx) => (
            <motion.li
              key={idx}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 + idx * 0.05 }}
              className="list-disc list-inside"
            >
              {item}
            </motion.li>
          ))}
          {combo.items.length > 4 && (
            <li className="italic text-gray-500 list-disc list-inside">...y más</li>
          )}
        </ul>

        <div className="mt-4">
          <Link to={`/combo/${combo.slug}`}>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="w-full bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary-dark transition-colors font-semibold shadow-md"
            >
              Ver detalles
            </motion.button>
          </Link>
        </div>
      </motion.div>
    </motion.div>
  );
}